// extracted by mini-css-extract-plugin
export default {"need_help":"need_help___K1E1Y","img":"img___kq7c0","text":"text___zpExt","btn":"btn___IEUot"};